export const BANK_OPTIONS = [
  { id: 1, name: 'Banco de Desarrollo Rural' },
  { id: 2, name: 'Banco Industrial S.A.' },
  { id: 3, name: 'Banco GYT Continental' },
  { id: 4, name: 'Banco Internacional S.A.' },
  { id: 5, name: 'Banco de America Central S.A.' },
];

export const mergeBankOptions = (bankAccounts = []) => {
  const byName = new Map();

  BANK_OPTIONS.forEach((bank) => {
    byName.set(bank.name, bank);
  });

  (Array.isArray(bankAccounts) ? bankAccounts : []).forEach((account) => {
    const name = String(account?.bankName || account?.name || '').trim();
    if (name && !byName.has(name)) {
      byName.set(name, { id: `account-${name}`, name });
    }
  });

  return Array.from(byName.values());
};
